import React from "react"
import tw from "twin.macro"

import supportSvg from "../images/support.svg"

import SEO from "../components/seo"
import Layout, { PageTitle, Leading } from "../components/layout"
import AppLink from "../components/app-link"

const SupportImg = tw.img`md:w-5/12`
const SideBySide = tw.div`flex flex-col md:flex-row justify-between`
const Content = tw.div`md:w-1/2`

const IndexPage = () => (
  <Layout>
    <SEO title="Support" />
    <PageTitle>Support</PageTitle>
    <SideBySide>
      <Content>
        <Leading>
          If you have any questions about using Labelscape, or if you have
          feedback or suggestions for new features, contact us at{" "}
          <AppLink href="mailto:MobileAppSupport@frontierscience.org">
            MobileAppSupport@frontierscience.org
          </AppLink>
        </Leading>
      </Content>
      <SupportImg src={supportSvg} />
    </SideBySide>
  </Layout>
)

export default IndexPage
